import React, { useState } from 'react';
import { Mail, Shield, FileText, HelpCircle, Heart, Instagram, Facebook, Youtube } from 'lucide-react';
import { FooterModal } from './FooterModal';
type ModalType = 'soporte' | 'contacto' | 'terminos' | 'privacidad' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#1e3a5f] text-gray-300" data-id="element-102">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-103">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-104">
            {/* Brand Section */}
            <div data-id="element-105">
              <div className="flex items-center gap-3 mb-4" data-id="element-106">
                <div className="w-12 h-12 bg-[#d4a574] rounded-lg flex items-center justify-center" data-id="element-107">
                  <span className="text-[#1e3a5f] font-bold text-xl" data-id="element-108">FF</span>
                </div>
                <h3 className="text-white font-serif font-bold text-xl" data-id="element-109">
                  Finanzas Fáciles
                </h3>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-110">
                Transformando mujeres en expertas de su propio dinero. Un método
                probado de 30 días para tomar el control financiero sin presión.
              </p>
              <div className="flex items-center gap-2 text-[#d4a574] text-sm" data-id="element-111">
                <Heart className="w-4 h-4 fill-current" data-id="element-112" />
                <span className="font-medium" data-id="element-113">
                  Hecho con pasión para emprendedoras
                </span>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-114">
              <h4 className="text-white font-bold text-lg mb-6" data-id="element-115">
                Enlaces Rápidos
              </h4>
              <ul className="space-y-3" data-id="element-116">
                <li data-id="element-117">
                  <button onClick={() => setActiveModal('soporte')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-118">
                    <HelpCircle className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-119" />
                    <span data-id="element-120">Centro de Soporte</span>
                  </button>
                </li>
                <li data-id="element-121">
                  <button onClick={() => setActiveModal('contacto')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-122">
                    <Mail className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-123" />
                    <span data-id="element-124">Contacto</span>
                  </button>
                </li>
                <li data-id="element-125">
                  <button onClick={() => setActiveModal('terminos')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-126">
                    <FileText className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-127" />
                    <span data-id="element-128">Términos y Condiciones</span>
                  </button>
                </li>
                <li data-id="element-129">
                  <button onClick={() => setActiveModal('privacidad')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-130">
                    <Shield className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-131" />
                    <span data-id="element-132">Política de Privacidad</span>
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div data-id="element-133">
              <h4 className="text-white font-bold text-lg mb-6" data-id="element-134">
                Conéctate con Nosotros
              </h4>

              {/* Email */}
              <div className="mb-6" data-id="element-135">
                <a href="mailto:contactomikioscodigital@gmail.com" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg transition-colors" data-id="element-136">
                  <Mail className="w-4 h-4" data-id="element-137" />
                  <span className="text-sm" data-id="element-138">
                    contactomikioscodigital@gmail.com
                  </span>
                </a>
              </div>

              {/* Social Media */}
              <div data-id="element-139">
                <p className="text-gray-400 text-sm mb-4" data-id="element-140">Mantente conectada</p>
                <div className="flex gap-3" data-id="element-141">
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-[#d4a574] rounded-xl flex items-center justify-center transition-all hover:scale-110 group" aria-label="Instagram" data-id="element-142">
                    <Instagram className="w-5 h-5 text-gray-300 group-hover:text-[#1e3a5f]" data-id="element-143" />
                  </a>
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-[#d4a574] rounded-xl flex items-center justify-center transition-all hover:scale-110 group" aria-label="Facebook" data-id="element-144">
                    <Facebook className="w-5 h-5 text-gray-300 group-hover:text-[#1e3a5f]" data-id="element-145" />
                  </a>
                  <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-[#d4a574] rounded-xl flex items-center justify-center transition-all hover:scale-110 group" aria-label="YouTube" data-id="element-146">
                    <Youtube className="w-5 h-5 text-gray-300 group-hover:text-[#1e3a5f]" data-id="element-147" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 bg-[#152d47]" data-id="element-148">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-149">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-150">
              <div className="flex items-center gap-6 text-xs text-gray-400" data-id="element-151">
                <p data-id="element-152">
                  © {new Date().getFullYear()} Finanzas Fáciles para Mujeres •
                  Todos los Derechos Reservados
                </p>
              </div>
              <div className="flex items-center gap-4 text-xs" data-id="element-153">
                <div className="flex items-center gap-2 text-green-400" data-id="element-154">
                  <Shield className="w-4 h-4" data-id="element-155" />
                  <span data-id="element-156">Pago Seguro</span>
                </div>
                <div className="flex items-center gap-2 text-[#d4a574]" data-id="element-157">
                  <span className="w-2 h-2 bg-[#d4a574] rounded-full animate-pulse" data-id="element-158"></span>
                  <span data-id="element-159">Entrega Inmediata</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-[#0f1f33] border-t border-white/5" data-id="element-160">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-161">
            <p className="text-xs text-gray-500 leading-relaxed text-center" data-id="element-162">
              <strong className="text-gray-400" data-id="element-163">
                Descargo de responsabilidad:
              </strong>{' '}
              Este producto tiene fines educativos e informativos únicamente. No
              constituye asesoría financiera personalizada. Los resultados
              pueden variar según el esfuerzo y la situación individual de cada
              persona. No garantizamos resultados específicos ni ganancias
              monetarias.
            </p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      {activeModal && <FooterModal isOpen={!!activeModal} onClose={() => setActiveModal(null)} type={activeModal} data-id="element-164" />}
    </>;
}